import { render, staticRenderFns } from "./SelectorDialog.vue?vue&type=template&id=010516f3&scoped=true"
import script from "./SelectorDialog.vue?vue&type=script&lang=js"
export * from "./SelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=010516f3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010516f3",
  null
  
)

export default component.exports